import { useTranslation } from 'react-i18next'
import { TypographyH2 } from '~/core/ui/Heading'
import LPContainer from './LPContainer'

const AboutUsSection = () => {
  const { t } = useTranslation()

  return (
    <LPContainer className="desktop:mt-[80px] mt-[40px]">
      <TypographyH2 className="leading-[52px] font-medium text-gray-900 text-[43px] tablet:text-[61px] tablet:leading-[61px] max-w-[804px] animate-fadeInUp">
        {t('aboutUs:title')}
      </TypographyH2>
    </LPContainer>
  )
}

export default AboutUsSection
